<template>
    <div class="bg-white p-4 rounded-md">
        <div class="flex items-center gap-4">
            <div
                class="
                    flex
                    items-center
                    gap-4
                    flex-grow flex-shrink
                    cursor-pointer
                "
                @click="toggleOpen"
            >
                <slot>
                    <div class="flex items-center flex-grow flex-shrink gap-4">
                        <img
                            src="default-images/icons/whistle-gray.svg"
                            alt="Whistle"
                            v-if="
                                playbook.playbook_id < 0 &&
                                !playbook.is_template
                            "
                        />
                        <img
                            src="default-images/icons/whistle-dark-blue.svg"
                            alt="Whistle"
                            v-else-if="playbook.is_template"
                        />
                        <img
                            src="default-images/icons/whistle.svg"
                            alt="Whistle"
                            v-else
                        />

                        <div class="flex-shrink">
                            <div class="flex gap-1 items-center">
                                <div class="text-base md:text-xl">
                                    {{ playbook.playbook_title }}
                                </div>

                                <div class="font-bold text-[#999999]">
                                    <div v-if="playbook.is_template">
                                        <span v-if="countTemplate(playbook) > 0"
                                            >({{ countTemplate(playbook) }})
                                        </span>
                                        <span
                                            v-else-if="
                                                playbook.plays?.length > 0
                                            "
                                            >({{
                                                playbook.plays?.length
                                            }})</span
                                        >
                                        <span v-else>(0)</span>
                                    </div>
                                    <div v-else>
                                        <span v-if="playbook.plays?.length > 0"
                                            >({{
                                                playbook.plays?.length
                                            }})</span
                                        >
                                        <span v-else>(0)</span>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="text-sm text-gray-500"
                                v-if="playbook.created_at"
                            >
                                Created {{ diffForHuman(playbook.created_at) }}
                            </div>
                        </div>
                    </div>
                </slot>
            </div>
            <button
                v-if="
                    playbook.plays?.length > 0 ||
                    playbook.child_playbooks?.length > 0
                "
                type="button"
                class="
                    p-2
                    hover:bg-gray-100
                    rounded
                    flex
                    items-center
                    justify-center
                "
                @click="toggleOpen"
            >
                <ion-icon v-if="!isOpen" name="chevron-down-outline"></ion-icon>
                <ion-icon v-else name="chevron-up-outline"></ion-icon>
            </button>
            <template v-if="canManage && playbook.plays?.length > 0">
                <template v-if="bulkSelection.isMode(selectionKey)">
                    <button
                        type="button"
                        class="
                            text-sm
                            py-1.5
                            px-3
                            rounded-lg
                            bg-red-500
                            text-white
                            hover:bg-red-600
                            disabled:opacity-50
                            flex
                            items-center
                            gap-1
                            whitespace-nowrap
                        "
                        :disabled="bulkSelection.count(selectionKey) === 0"
                        @click="confirmOpen = true"
                    >
                        <ion-icon name="trash-outline"></ion-icon>
                        Delete ({{ bulkSelection.count(selectionKey) }})
                    </button>
                    <button
                        type="button"
                        class="
                            text-sm
                            py-1.5
                            px-3
                            rounded-lg
                            border border-gray-300
                            hover:bg-gray-100
                            whitespace-nowrap
                        "
                        @click="bulkSelection.setMode(selectionKey, false)"
                    >
                        Cancel
                    </button>
                </template>
            </template>
            <context-menu v-if="playbook.playbook_id == -3">
                <li>
                    <Modal title="Create New Template Group">
                        <button
                            class="
                                py-1.5
                                pl-4
                                pr-8
                                flex flex-row
                                items-center
                                text-left
                                gap-2
                                cursor-pointer
                                hover:bg-gray-300
                                rounded-lg
                            "
                        >
                            <ion-icon
                                name="add-outline"
                                class="text-xl mr-2"
                            ></ion-icon>
                            Create New Template Group
                        </button>

                        <template #body="{ close }">
                            <div class="my-b text-gray-400 text-sm">
                                Let's start creating a template group, you can
                                organize your templates better.
                            </div>
                            <hr class="gray-500 my-4" />
                            <form action="/playbook/store" method="post">
                                <input
                                    type="hidden"
                                    name="_token"
                                    :value="$root.csrfToken"
                                />
                                <input
                                    type="hidden"
                                    name="team_id"
                                    :value="teamIdFromUrl"
                                    v-if="isTeamPlaybook"
                                />
                                <input
                                    type="hidden"
                                    name="is_template"
                                    value="1"
                                />
                                <div class="my-2">
                                    <label
                                        for="name"
                                        class="block font-semibold my-2 text-sm"
                                    >
                                        Template Name
                                    </label>
                                    <new-input
                                        required
                                        maxlength="128"
                                        label="Name"
                                        name="playbook_title"
                                        placeholder="Enter template name"
                                    ></new-input>
                                </div>

                                <div class="mt-4" v-if="isTeamPlaybook">
                                    <div class="mb-2 font-bold">Access</div>

                                    <div class="flex gap-2">
                                        <tag-form
                                            :available-tags="availableTags"
                                        ></tag-form>
                                    </div>
                                </div>
                                <div
                                    class="
                                        mt-8
                                        flex
                                        items-center
                                        gap-4
                                        justify-end
                                    "
                                >
                                    <app-button
                                        @click="close"
                                        type="submit"
                                        class="
                                            border border-accent
                                            text-accent
                                            !bg-white
                                        "
                                    >
                                        Cancel
                                    </app-button>
                                    <app-button
                                        type="submit"
                                        class="bg-primary text-white"
                                        >Create Template</app-button
                                    >
                                </div>
                            </form>
                        </template>
                    </Modal>
                </li>
            </context-menu>
            <context-menu class="" v-if="playbook.playbook_id >= -1">
                <li>
                    <Modal
                        :title="
                            playbook.is_template
                                ? 'Create Template'
                                : 'Create Play'
                        "
                    >
                        <a
                            class="
                                py-1.5
                                pl-4
                                pr-8
                                flex flex-row
                                items-center
                                text-left
                                gap-2
                                cursor-pointer
                                hover:bg-gray-300
                                rounded-lg
                            "
                        >
                            <ion-icon name="add-circle-outline"></ion-icon>
                            <div class="flex-grow-1 flex-shrink-0 font-slab">
                                {{
                                    playbook.is_template
                                        ? "Create Template"
                                        : "Create Play"
                                }}
                            </div>
                        </a>
                        <template #body>
                            <form :action="createPlayApi" method="post">
                                <input
                                    type="hidden"
                                    name="_token"
                                    :value="$root.csrfToken"
                                />
                                <input
                                    type="hidden"
                                    name="playbook_id"
                                    :value="playbook.playbook_id"
                                />
                                <input
                                    type="hidden"
                                    name="team_id"
                                    :value="teamIdFromUrl"
                                />
                                <input
                                    type="hidden"
                                    name="is_template"
                                    value="1"
                                    v-if="playbook.is_template"
                                />
                                <div class="my-2">
                                    <app-input
                                        label="Name"
                                        name="play_name"
                                        required
                                        maxlength="128"
                                        :placeholder="
                                            playbook.is_template
                                                ? 'Enter template name'
                                                : 'Enter play name'
                                        "
                                    ></app-input>
                                </div>
                                <div class="my-4 text-right">
                                    <app-button
                                        type="submit"
                                        class="!bg-primary text-white"
                                        >Create
                                    </app-button>
                                </div>
                            </form>
                        </template>
                    </Modal>
                </li>
                <li v-if="playbook.plays?.length > 0">
                    <ModalDownloadPlaybook
                        :playbook="playbook"
                        :sport-type="props.sportType"
                    >
                        <button
                            class="
                                py-1.5
                                pl-4
                                pr-8
                                flex flex-row
                                items-center
                                text-left
                                gap-2
                                cursor-pointer
                                hover:bg-gray-300
                                rounded-lg
                            "
                        >
                            <ion-icon name="download-outline"></ion-icon>
                            <div
                                class="flex-grow-1 flex-shrink-0 font-slab"
                                v-if="playbook.is_template"
                            >
                                Download Template
                            </div>
                            <div
                                class="flex-grow-1 flex-shrink-0 font-slab"
                                v-else
                            >
                                Download Playbook
                            </div>
                        </button>
                    </ModalDownloadPlaybook>
                </li>

                <li v-if="canManage && playbook.playbook_title != 'Draft'">
                    <PlaybookSettings
                        :playbook="playbook"
                        :available-tags="availableTags"
                        :update-api="updateApi"
                    />
                </li>
                <li
                    ref="copyTeamPlaybookRef"
                    @click.prevent.stop="showCopyTeamPlaybook = true"
                    v-if="
                        playbook.playbook_title != 'Draft' &&
                        !isTeamPlaybook &&
                        !playbook.is_template
                    "
                >
                    <a
                        class="
                            py-1
                            pl-4
                            pr-8
                            flex flex-row
                            items-center
                            text-left
                            gap-2
                            cursor-pointer
                            hover:bg-gray-300
                            rounded-lg
                        "
                    >
                        <ion-icon
                            class="flex-grow-0 flex-shrink-0"
                            name="log-out-outline"
                        ></ion-icon>
                        <div class="flex-grow flex-shrink font-slab mt-1">
                            Copy to Team Playbook
                        </div>
                    </a>
                </li>

                <li v-if="canManage && playbook.plays?.length > 0">
                    <template v-if="!bulkSelection.isMode(selectionKey)">
                        <button
                            type="button"
                            class="
                                text-red-500
                                py-1
                                pl-4
                                pr-8
                                flex flex-row
                                items-center
                                text-left
                                gap-2
                                cursor-pointer
                                hover:bg-gray-300
                                rounded-lg
                                w-full
                            "
                            @click="bulkSelection.setMode(selectionKey, true)"
                        >
                            <ion-icon name="trash-outline"></ion-icon>
                            Bulk Delete
                        </button>
                    </template>
                </li>
                <li
                    @click="$refs.deleteForm.submit()"
                    v-if="canManage && playbook.playbook_title != 'Draft'"
                >
                    <form :action="deleteApi" method="post" ref="deleteForm">
                        <input
                            type="hidden"
                            name="_token"
                            :value="$root.csrfToken"
                        />
                        <input
                            type="hidden"
                            name="playbook_id"
                            :value="playbook.playbook_id"
                        />
                        <div
                            class="
                                py-1
                                pl-4
                                pr-8
                                flex flex-row
                                items-center
                                text-left
                                gap-2
                                cursor-pointer
                                hover:bg-gray-300
                                rounded-lg
                                text-red-500
                            "
                        >
                            <ion-icon name="trash-outline"></ion-icon>
                            <button
                                type="submit"
                                class="flex-grow-1 flex-shrink-0 font-slab"
                            >
                                Delete
                            </button>
                        </div>
                    </form>
                </li>
            </context-menu>
        </div>
        <div
            v-if="playbook.child_playbooks?.length > 0"
            v-show="isOpen && playbook.child_playbooks?.length > 0"
        >
            <div
                v-for="template in playbook.child_playbooks"
                :key="template.playbook_id"
            >
                <PlaybookCard
                    :display-mode="displayMode"
                    :update-api="updateApi"
                    :delete-api="deleteApi"
                    :create-play-api="createPlayApi"
                    :copy-playbook-api="copyPlaybookApi"
                    :playbook="template"
                    :playbooks="playbook.child_playbooks"
                    :video-api="videoApi"
                    :teams="teams"
                    :available-tags="availableTags"
                    :is-team-playbook="isTeamPlaybook"
                    :sport-type="props.sportType"
                    :canManage="canManage"
                />
            </div>
        </div>
        <div
            id="mobile-play-container"
            class="grid-cols-1 md:grid-cols-3 gap-4 my-4"
            v-show="isOpen && playbook.plays?.length > 0"
        >
            <div
                class="
                    p-4
                    md:p-8
                    bg-gray-100
                    rounded-lg
                    relative
                    group
                    flex flex-col
                    border-gray-300 border
                    flex-wrap
                "
                v-for="element in playbook.plays"
                :style="`flex-direction: ${
                    displayMode === 'grid' ? 'column' : 'row'
                };  ${
                    displayMode === 'list' ? 'padding: 10px; gap:10px;' : ''
                }`"
                :key="element.play_id"
            >
                <PlayCardNew
                    :formations="formations"
                    :packages="packages"
                    :display-mode="displayMode"
                    :playbook="playbook"
                    :playbooks="playbooks"
                    whiteboard-api="{{env('APP_WHITEBOARD_BASE')}}"
                    move-api="/plays/move-play-api"
                    copy-api="/plays/copy-play-api"
                    mirror-api="/plays/mirror-play-api"
                    copy-playbook-api="/playbook/copy-playbook-api"
                    delete-api="/plays/deleted-api"
                    :can-share="playbook.playbook_id !== -2"
                    :can-manage="canManage"
                    :teams="teams"
                    :play="element"
                    :thumbnail="
                        element.team_id
                            ? `${previewUrl}${element.team_id}.'/'.${element.play_preview}`
                            : ``
                    "
                    :team-id="playbook.team_id"
                    :href="`/plays/show?playId=${element.play_id}&mode=${displayMode}`"
                    :is-team-playbook="isTeamPlaybook"
                    :key="element.play_id"
                    :video-api="videoApi"
                    :updateVideoTagsApi="updateVideoTagsApi"
                    :is-shared="sharedStatus?.includes(element.play_id)"
                    :mirrors="getMirrors(element)"
                >
                </PlayCardNew>
            </div>
        </div>

        <draggable
            v-model="state.plays"
            :group="{ name: playbook.playbook_id }"
            id="desktop-play-container"
            class="grid-cols-1 md:grid-cols-3 gap-4 my-4"
            :style="`${
                displayMode === 'list' ? 'grid-template-columns: 1fr' : ''
            }`"
            v-show="isOpen && playbook.plays?.length > 0"
            @end="sortPlays"
        >
            <template #item="{ element }">
                <div
                    class="
                        border-gray-300 border
                        bg-gray-100
                        rounded-lg
                        flex
                        p-4
                        md:p-8
                        relative
                        flex-wrap
                    "
                    :style="`${
                        displayMode === 'list' ? 'padding: 10px;gap:20px' : ''
                    }`"
                >
                    <PlayCardNew
                        v-if="element"
                        :formations="formations"
                        :packages="packages"
                        :display-mode="displayMode"
                        :playbook="playbook"
                        :playbooks="playbooks"
                        whiteboard-api="{{env('APP_WHITEBOARD_BASE')}}"
                        move-api="/plays/move-play-api"
                        copy-api="/plays/copy-play-api"
                        mirror-api="/plays/mirror-play-api"
                        copy-playbook-api="/playbook/copy-playbook-api"
                        delete-api="/plays/deleted-api"
                        :can-share="playbook.playbook_id !== -2"
                        :can-manage="canManage"
                        :teams="teams"
                        :play="element"
                        :thumbnail="
                            element.team_id
                                ? `${previewUrl}${element.team_id}.'/'.${element.play_preview}`
                                : ``
                        "
                        :team-id="playbook.team_id"
                        :href="`/plays/show?playId=${element.play_id}&mode=${displayMode}`"
                        :is-team-playbook="isTeamPlaybook"
                        :key="element.play_id"
                        :video-api="videoApi"
                        :updateVideoTagsApi="updateVideoTagsApi"
                        :is-shared="sharedStatus?.includes(element.play_id)"
                        :mirrors="getMirrors(element.play_id)"
                    >
                    </PlayCardNew>
                </div>
            </template>
        </draggable>
    </div>
    <Teleport to="body" v-show="showCopyTeamPlaybook">
        <div
            class="fixed w-full h-full z-30 top-0 left-0"
            v-if="showCopyTeamPlaybook"
            @click.self="showCopyTeamPlaybook = false"
        ></div>
        <div
            ref="copyTeamPlaybookPopup"
            class="absolute bg-gray-200 shadow-xl rounded-lg z-40 text-black"
            v-show="showCopyTeamPlaybook"
        >
            <div class="p-2">
                <div class="flex flex-col gap-2">
                    <form
                        v-for="team in teams"
                        method="post"
                        :action="copyPlaybookApi"
                        :key="team.id"
                    >
                        <input type="hidden" name="team_id" :value="team.id" />
                        <input
                            type="hidden"
                            name="playbook_id"
                            :value="playbook.playbook_id"
                        />
                        <input
                            type="hidden"
                            name="_token"
                            :value="$root.csrfToken"
                        />
                        <button
                            type="submit"
                            class="
                                bg-gray-100
                                py-2
                                px-3
                                rounded-md
                                hover:bg-primary hover:text-white
                                cursor-pointer
                            "
                        >
                            {{ team.name }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </Teleport>

    <MiniModalCustom
        :is-open="confirmOpen"
        title="Delete Plays"
        @close="confirmOpen = false"
        z-index="1003"
    >
        <p class="text-sm text-gray-700">
            Are you sure you want to delete
            <span class="font-semibold">{{
                bulkSelection.count(selectionKey)
            }}</span>
            selected play<span v-if="bulkSelection.count(selectionKey) !== 1"
                >s</span
            >? This action cannot be undone.
        </p>
        <div class="mt-6 flex justify-end gap-3">
            <button
                type="button"
                class="
                    border border-gray-300
                    rounded-lg
                    py-2
                    px-4
                    hover:bg-gray-100
                "
                :disabled="deleting"
                @click="confirmOpen = false"
            >
                Cancel
            </button>
            <button
                type="button"
                class="
                    bg-red-500
                    text-white
                    rounded-lg
                    py-2
                    px-4
                    hover:bg-red-600
                    disabled:opacity-60
                "
                :disabled="deleting"
                @click="bulkDeletePlays"
            >
                {{ deleting ? "Deleting…" : "Delete" }}
            </button>
        </div>
    </MiniModalCustom>
</template>

<script setup>
import ModalCustom from "./ModalCustom";
import MiniModalCustom from "./MiniModalCustom";
import bulkSelection from "../stores/bulkSelection";
import TagForm from "./TagForm";
import PlaybookSettings from "./PlaybookSettings.vue";
import { diffForHuman } from "../utils/date";
import { createPopper } from "@popperjs/core";
import Modal from "./Modal";
import AppInput from "./AppInput";
import AppButton from "./AppButton";
import { ref, onMounted, computed, watch, nextTick, reactive } from "vue";
import PlayCardNew from "./PlayCardNew.vue";
import draggable from "vuedraggable";

const props = defineProps({
    updateApi: {
        type: String,
        required: true,
    },
    deleteApi: {
        type: String,
        required: true,
    },
    createPlayApi: {
        type: String,
        required: true,
    },
    copyPlaybookApi: {
        type: String,
        required: true,
    },
    playbook: {
        type: Object,
        required: true,
    },
    playbooks: {
        type: Array,
        required: true,
    },
    mirrors: {
        type: Array,
    },
    previewUrl: {
        type: String,
        required: true,
    },
    availableTags: {
        type: Array,
        required: true,
    },
    canManage: {
        default: false,
        type: Boolean,
    },
    isTeamPlaybook: {
        default: false,
        type: Boolean,
    },
    teams: {
        default: [],
        type: Array,
        required: false,
    },
    updateVideoTagsApi: {
        type: String,
    },
    videoApi: {
        type: String,
    },
    sportType: {
        type: String,
    },
    sharedStatus: {
        type: Array,
    },
    displayMode: {
        type: String,
        default: "grid",
    },
    formations: {
        type: Array,
    },
    packages: {
        type: Array,
    },
});

const state = reactive({
    plays: props.playbook.plays,
});

const isOpen = ref(false);
const showCopyTeamPlaybook = ref(false);
const copyTeamPlaybookRef = ref(null);
const copyTeamPlaybookPopup = ref(null);
const teamIdFromUrl = new URLSearchParams(window.location.search).get("teamId");
const popperInstance = ref(null);

// Bulk-selection / bulk-delete
const selectionKey = computed(() => `playbook-${props.playbook.playbook_id}`);
const confirmOpen = ref(false);
const deleting = ref(false);

async function bulkDeletePlays() {
    const ids = bulkSelection.selected(selectionKey.value);
    if (ids.length === 0) {
        return;
    }
    deleting.value = true;
    try {
        await axios.post("/plays/bulk-deleted-api", { play_ids: ids });
        window.location.reload();
    } catch (e) {
        console.error(e);
        deleting.value = false;
        confirmOpen.value = false;
    }
}

const countTemplate = function (playbook) {
    if (!playbook.child_playbooks) {
        return 0;
    }
    let total = 0;
    playbook.child_playbooks.map((p) => (total += p.plays.length));
    return total;
};

function getStorageKey() {
    let storageKey = "my_playbooks_open";
    if (teamIdFromUrl) {
        storageKey = "team_" + teamIdFromUrl + "_playbooks_open";
    }
    return storageKey;
}

function toggleOpen() {
    isOpen.value = !isOpen.value;

    let currentOpenIndexes = [];
    try {
        currentOpenIndexes = JSON.parse(
            sessionStorage.getItem(getStorageKey())
        );
    } catch (e) {}
    if (!currentOpenIndexes) {
        currentOpenIndexes = [];
    }

    if (isOpen.value) {
        if (!currentOpenIndexes.includes(props.playbook.playbook_id)) {
            currentOpenIndexes.push(props.playbook.playbook_id);
            sessionStorage.setItem(
                getStorageKey(),
                JSON.stringify(currentOpenIndexes)
            );
        }
    } else {
        currentOpenIndexes.splice(
            currentOpenIndexes.indexOf(props.playbook.playbook_id),
            1
        );
        sessionStorage.setItem(
            getStorageKey(),
            JSON.stringify(currentOpenIndexes)
        );
    }
}

watch(showCopyTeamPlaybook, (newValue) => {
    if (newValue) {
        nextTick(() => {
            popperInstance.value = createPopper(
                copyTeamPlaybookRef.value,
                copyTeamPlaybookPopup.value,
                {
                    placement: "left",
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [0, 8],
                            },
                        },
                    ],
                }
            );

            popperInstance.value.forceUpdate();
        });
    } else {
        popperInstance.value.destroy();
    }
});

async function sortPlays() {
    let meta = [];
    for (let i = 0; i < state.plays.length; i++) {
        const play = state.plays[i];
        const sort = i + 1;
        if (play.sort !== sort) {
            meta.push({
                id: play.play_id,
                sort,
            });
            state.plays[i].sort = sort;
        }
    }

    if (meta.length > 0) {
        await axios.post(`/plays/${props.playbook.playbook_id}/sort`, meta);
    }
}

function getMirrors(play_id) {
    return (
        props.mirrors
            ?.find((m) => m.play_id === play_id)
            ?.mirrors?.map((m) => parseInt(m)) || []
    );
}

function getOpenState() {
    let currentOpenIndexes = [];
    try {
        currentOpenIndexes = JSON.parse(
            sessionStorage.getItem(getStorageKey())
        );
    } catch (e) {}
    if (!currentOpenIndexes) {
        return;
    }
    isOpen.value = currentOpenIndexes.includes(props.playbook.playbook_id);
}

async function downloadPlaybook() {
    console.log({ a: props.playbook });

    for (const play of props.playbook.plays) {
        const resp = await axios.get("/plays/get-play-data", {
            params: { play_id: play.play_id },
        });
        console.log({ a: resp.data });
    }
}

onMounted(() => {
    getOpenState();
});
</script>

<style scoped>
@media (max-width: 720px) {
    #mobile-play-container {
        display: grid;
    }
    #desktop-play-container {
        display: none;
    }
}
@media (min-width: 720px) {
    #mobile-play-container {
        display: none;
    }
    #desktop-play-container {
        display: grid;
    }
}
</style>
